import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Dialog zum Umbenennen der aktuellen Messung (Session-Name).
 * Verwendet dieselben Klassen wie SaveDialog (edit-overlay, edit-modal, edit-header, …).
 */
function RenameSessionDialog({ open, sessionName, onSessionNameChange, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!open) return null;

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trimmed = (sessionName || '').trim();
      if (trimmed) onConfirm();
    }
  };

  return (
    <div className="edit-overlay" onClick={onCancel}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>{t('dialog.rename_session.title')}</h3>
          <button className="btn-close" onClick={onCancel} type="button">×</button>
        </div>
        <div className="edit-content">
          <div className="edit-field">
            <label>{t('dialog.rename_session.label')}</label>
            <input
              type="text"
              value={sessionName ?? ''}
              onChange={(e) => onSessionNameChange(e.target.value)}
              onKeyDown={handleKeyDown}
              className="edit-input"
              placeholder={t('dialog.rename_session.placeholder')}
              autoFocus
            />
          </div>
        </div>
        <div className="edit-actions">
          <button
            className="btn btn-primary"
            onClick={onConfirm}
            disabled={!(sessionName || '').trim()}
            title={t('dialog.rename_session.apply_title')}
            type="button"
          >
            {t('dialog.rename_session.apply')}
          </button>
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            title={t('dialog.cancel')}
            type="button"
          >
            {t('dialog.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default RenameSessionDialog;
